import React from 'react';
import { Link } from 'react-router-dom';

// ComplyKit Logo Component with shield icon and two-color wordmark
const Logo = ({ className = '', size = 'default', linkTo = '/' }) => {
  // Size presets with tightened letter-spacing for premium look
  const sizes = {
    small: {
      icon: 'h-5 w-5',
      text: 'text-base',
      gap: 'gap-1.5',
      tracking: '-tracking-[0.02em]',
    },
    default: {
      icon: 'h-6 w-6',
      text: 'text-lg',
      gap: 'gap-2',
      tracking: '-tracking-[0.02em]',
    },
    large: {
      icon: 'h-7 w-7',
      text: 'text-xl',
      gap: 'gap-2.5',
      tracking: '-tracking-[0.03em]',
    },
  };

  const currentSize = sizes[size] || sizes.default;

  // Shield with checkmark SVG icon (green/teal brand trust color)
  const ShieldIcon = () => (
    <svg 
      viewBox="0 0 40 44" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={`${currentSize.icon} flex-shrink-0`}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="shieldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#38BDF8" />
          <stop offset="50%" stopColor="#10B981" />
          <stop offset="100%" stopColor="#34D399" />
        </linearGradient>
      </defs>
      {/* Shield shape */}
      <path 
        d="M20 2L4 9V20C4 31.05 10.68 41.22 20 44C29.32 41.22 36 31.05 36 20V9L20 2Z" 
        fill="url(#shieldGradient)"
      />
      {/* Checkmark */}
      <path 
        d="M16 22L19 25L26 17" 
        stroke="white" 
        strokeWidth="3" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );

  const LogoContent = () => (
    <div className={`flex items-center ${currentSize.gap} ${className}`}>
      <ShieldIcon />
      <span className={`font-bold ${currentSize.text} ${currentSize.tracking}`}>
        {/* COMPLY with gradient matching "simple and clear" headline */}
        <span className="bg-gradient-to-r from-blue-600 via-violet-600 to-emerald-600 bg-clip-text text-transparent">
          COMPLY
        </span>
        {/* KIT in solid near-black */}
        <span className="text-slate-900">KIT</span>
      </span>
    </div>
  );

  if (linkTo) {
    return (
      <Link 
        to={linkTo}
        className="hover:opacity-90 transition-opacity"
        data-testid="logo-link"
      >
        <LogoContent />
      </Link>
    );
  }

  return <LogoContent />;
};

export default Logo;
